import type { LayoutQueryFilter } from "@package/ui-gql/index-data-access";
import { type WritableDraft } from "immer";
import { useItemGridFilterContext } from "../ItemGridFilter/context-item-grid-filter";
import { ItemGridFilterBoolean } from "../ItemGridFilter/ItemGridFilterBoolean";

type SupportedFilter = LayoutQueryFilter | null | undefined;

export function ItemGridFilterAnimationEnabled() {
  const { filter, updateFilterState } = useItemGridFilterContext();

  const filterWithAnimationEnabled: SupportedFilter = filter;

  return (
    <ItemGridFilterBoolean
      checked={filterWithAnimationEnabled?.animationEnabled ?? undefined}
      property="animationEnabled"
      text="Animation Enabled"
      onRequestFilterReset={() =>
        updateFilterState((draft: WritableDraft<SupportedFilter>) => {
          if (draft) {
            delete draft.animationEnabled;
          }
        })
      }
      onRequestFilterUpdate={() =>
        updateFilterState((draft: WritableDraft<SupportedFilter>) => {
          if (draft) {
            if (filterWithAnimationEnabled?.animationEnabled === true) {
              draft.animationEnabled = false;
            } else if (filterWithAnimationEnabled?.animationEnabled === false) {
              delete draft.animationEnabled;
            } else {
              draft.animationEnabled = true;
            }
          }
        })
      }
    />
  );
}
